<template>
	<div style="background-color:#FFF">
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100 text-center">
				<h3 class="order-title" style="padding-top: 20px">{{title}}<br>

				</h3>
			</div>

			<!-- <img src="@/assets/img/logo-black.jpg" class="print-logo"> -->
			<div class="md-layout-item md-small-size-100 md-size-100">
				<md-table v-if="driverFeeList.length > 0" style="margin-top: 30px;">
					<md-table-row class="no-hover">
						<md-table-cell class="small-size">លេខកូដ</md-table-cell>
						<md-table-cell class="small-size">កញ្ចប់សរុប</md-table-cell>
						<md-table-cell class="small-size">កញ្ចប់បានត្រឡប់</md-table-cell>
						<md-table-cell class="small-size">កញ្ចប់បានដឹកដល់អតិថិជន</md-table-cell>
						<md-table-cell class="small-size">ប្រាក់ត្រូវទូទាត់</md-table-cell>
					</md-table-row>

					<md-table-row class="no-hover" v-for="(driver, index) in driverFeeList">
						<md-table-cell class="small-size no-hover">​{{ index + 1 }}, <b>{{ driver.driver_name
						}}</b> - {{driver.driver_note}}</md-table-cell>
						<md-table-cell class="small-size no-hover">
							{{driver.total_package}}
						</md-table-cell>
						<md-table-cell class="small-size no-hover">{{driver.total_returned}}</md-table-cell>
						<md-table-cell class="small-size no-hover">{{driver.total_delivered}}</md-table-cell>
						<md-table-cell class="small-size no-hover"><b>{{config.moneylify(driver.total_payment, 'khr')}}</b> </md-table-cell>
					</md-table-row>
					<md-table-row class="no-hover">
						<md-table-cell>​</md-table-cell>
						<md-table-cell></md-table-cell>
						<md-table-cell style="text-align: right;"><b>ទឹកប្រាក់ត្រូវទូទាត់:</b></md-table-cell>
						<md-table-cell colspan="2" style="text-align: center;"><b>{{config.moneylify(0,'usd')}} + {{config.moneylify(total_fee, 'khr')}}</b></md-table-cell>
						<md-table-cell></md-table-cell>
					</md-table-row>
				</md-table>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		created() {
			this.searchFeeDriver();
		},
		mounted() { },
		data() {
			return {
				loaded: true,
				title: "",
				total_fee: "",
				driverFeeList: [],
				client: {
					client_hash_id: "",
					client_name: "",
					client_phone: "",
					client_note: ""
				}
			}
		},
		methods: {
			searchFeeDriver() {
				this.$http.post(this.config.api + "/admin/driver/get/fee", {
					text: ""
				}).then(data => {
					if (data.body.status == 'success') {
						this.driverFeeList = data.body.data
						this.$http.get(this.config.api + "/admin/driver/get/total_fee").then(data => {
							if (data.body.status == 'success') {
								this.total_fee = data.body.data.total_fee
								this.loaded = true;
								let d = new Date();
								this.title = `ការទូទាត់ប្រាក់អ្នកដឹកជញ្ជូន ${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`;
								document.title = this.title;
								setTimeout(() => {

									window.print();
								}, 1000)
							}
						})
					}
					// this.loadMoreCompanyButton = true
				})

			},

		}
	}
</script>

<style>
    /* @media print {
        body {
            page: a4;
        }
    } */

	.small-size {
		font-size: 11px !important;
	}

	.dot {
		padding: 0 30px;
	}

	.no-hover:hover {
		background-color: #FFF !important;
	}

	body {
		background-color: #FFF !important;
	}

	.print-logo {
		height: 100px !important;
		margin: 16px;
	}

	.order-title {
		margin-top: 0;
		margin-bottom: 0;
	}

	.product-thumbnail {
		width: 64px;
		height: 64px;
		margin-right: 13px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/PrintPaymentDriver.vue